import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';

const FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

export const saveWorkbook = ({ workbook, fileName}) => {
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], { type: FILE_TYPE });
  saveAs(blob, `${fileName}.xlsx`)
}